import { Component } from '@angular/core';

@Component({
  selector: 'app-assessment-expire',
  templateUrl: './assessment-expire.component.html',
  styleUrls: ['./assessment-expire.component.scss']
})
export class AssessmentExpireComponent {

}
